// @flow

import * as React from 'react';

type Props = {|
  /** The list of React event handler attributes you'd like to bound to within this component */
  events: string[],

  /** Optional class name for customization, since this component renders an element wrapping its children. */
  className?: string,

  /** The child React Elements from whom you'd like to block event bubbling */
  children: React.Node,
|};

/** stopPropagation event */
export const stopPropagation = (e: any) => {
  e.stopPropagation();
};

/**
 * EventBoundary lets you prevent events from bubbling up beyond it.
 *
 * For example, if you were to add an EventBoundary on the events ['onClick', 'onDoubleCLick'], any time a user clicked
 * or double clicked inside of that EventBoundary's React children those click and/or double click events would not
 * bubble up beyond it (including up to the Window).
 */
const EventBoundary = ({ events, className, children }: Props) => (
  <div
    className={className}
    {...events.reduce((accum, event) => ({ ...accum, [event]: stopPropagation }), {})}
  >
    {children}
  </div>
);

EventBoundary.defaultProps = {
  className: undefined,
};

export default EventBoundary;
